import { useQuery } from 'react-query';
import CardRelatorio from '../CardRelatorio';
import Valor from '../Valor';
import Badge from '../../../components/layout/Badge';
import axios from 'axios';
import Skeleton from '../../../components/layout/Skeleton';
import VBox from '../../../components/layout/VBox';
import { format, startOfMonth, endOfMonth, subMonths } from 'date-fns';
import { translateFilterFinanceiro } from './util';

const buscarSaldo = async (dataInicio: string, dataFim: string) => {
  const qs = new URLSearchParams();
  qs.append('facts', 'saldo');
  qs.append('filter', translateFilterFinanceiro(dataInicio, dataFim));

  const res = await axios.get('/api/relatorios/lancamento_financeiro?' + qs.toString());
  return res.data.result?.[0]?.saldo ? +res.data.result[0].saldo : 0;
};

const CardComparativoMensal = () => {
  const hoje = new Date();
  const inicioMesAtual = format(startOfMonth(hoje), 'yyyy-MM-dd');
  const fimMesAtual = format(hoje, 'yyyy-MM-dd');
  const mesAnterior = subMonths(hoje, 1);
  const inicioMesAnterior = format(startOfMonth(mesAnterior), 'yyyy-MM-dd');
  const fimMesAnterior = format(endOfMonth(mesAnterior), 'yyyy-MM-dd');

  const q = useQuery(
    ['financeiroComparativoMensal'],
    async () => {
      const [atual, anterior] = await Promise.all([
        buscarSaldo(inicioMesAtual, fimMesAtual),
        buscarSaldo(inicioMesAnterior, fimMesAnterior),
      ]);
      return { atual, anterior };
    },
    { refetchOnWindowFocus: false },
  );

  const variacao =
    q.data && q.data.anterior !== 0
      ? ((q.data.atual - q.data.anterior) / Math.abs(q.data.anterior)) * 100
      : null;

  return (
    <CardRelatorio titulo="Saldo do mês vs mês anterior">
      {q.isFetching ? (
        <Skeleton format="box" />
      ) : (
        <VBox gap="4px">
          <Valor
            valor={q.data?.atual ?? 0}
            prepend="R$"
            digits={2}
            valueSize="1.8rem"
            fractionSize="1.1rem"
          />
          {variacao !== null && (
            <Badge variant={variacao >= 0 ? 'success' : 'danger'}>
              {variacao >= 0 ? '▲' : '▼'} {Math.abs(variacao).toFixed(1)}% vs mês anterior
            </Badge>
          )}
        </VBox>
      )}
    </CardRelatorio>
  );
};

export default CardComparativoMensal;
